var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpIntegrationOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1049_11520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 54,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2647 65.2055C72.3682 65.2055 69.2059 68.3679 69.2059 72.2644C69.2059 76.1608 72.3682 79.3232 76.2647 79.3232C80.1612 79.3232 83.3235 76.1608 83.3235 72.2644C83.3235 68.3679 80.1612 65.2055 76.2647 65.2055ZM79.0882 72.9702H76.9706V75.0879C76.9706 75.4761 76.6529 75.7938 76.2647 75.7938C75.8765 75.7938 75.5588 75.4761 75.5588 75.0879V72.9702H73.4412C73.0529 72.9702 72.7353 72.6526 72.7353 72.2644C72.7353 71.8761 73.0529 71.5585 73.4412 71.5585H75.5588V69.4408C75.5588 69.0526 75.8765 68.735 76.2647 68.735C76.6529 68.735 76.9706 69.0526 76.9706 69.4408V71.5585H79.0882C79.4765 71.5585 79.7941 71.8761 79.7941 72.2644C79.7941 72.6526 79.4765 72.9702 79.0882 72.9702Z",
    fill: "#3F62DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 54.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "#546FFF",
    strokeOpacity: 0.5,
    strokeDasharray: "3 3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1049_11520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 10,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_11520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1708 17.1539C70.5403 17.1539 70.8918 19.5957 70.8918 19.5957L70.8981 22.1254H76.2712V22.8849H68.7639C68.7639 22.8849 65.1609 22.4763 65.1609 28.1575C65.1609 33.8389 68.3057 33.6374 68.3057 33.6374H70.1825V31.001C70.1825 31.001 70.0813 27.8562 73.2771 27.8562H78.6063C78.6063 27.8562 81.6004 27.9046 81.6004 24.9625V20.0979C81.6004 20.0979 82.0551 17.1539 76.1708 17.1539ZM73.2081 18.8551C73.335 18.855 73.4608 18.8799 73.5781 18.9285C73.6954 18.977 73.802 19.0482 73.8918 19.138C73.9816 19.2278 74.0528 19.3344 74.1013 19.4517C74.1499 19.569 74.1748 19.6948 74.1747 19.8217C74.1748 19.9487 74.1499 20.0745 74.1013 20.1918C74.0528 20.3091 73.9816 20.4157 73.8918 20.5055C73.802 20.5953 73.6954 20.6665 73.5781 20.715C73.4608 20.7636 73.335 20.7885 73.2081 20.7884C73.0811 20.7885 72.9553 20.7636 72.838 20.715C72.7207 20.6665 72.6141 20.5953 72.5243 20.5055C72.4345 20.4157 72.3633 20.3091 72.3148 20.1918C72.2663 20.0745 72.2413 19.9487 72.2414 19.8217C72.2413 19.6948 72.2663 19.569 72.3148 19.4517C72.3633 19.3344 72.4345 19.2278 72.5243 19.138C72.6141 19.0482 72.7207 18.977 72.838 18.9285C72.9553 18.8799 73.0811 18.855 73.2081 18.8551Z",
    fill: "url(#paint0_linear_1049_11520)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3292 39.2171C81.9598 39.2171 81.6082 36.7754 81.6082 36.7754L81.602 34.2457H76.2288V33.4862H83.736C83.736 33.4862 87.339 33.8949 87.339 28.2135C87.339 22.5322 84.1942 22.7337 84.1942 22.7337H82.3174V25.37C82.3174 25.37 82.4186 28.5148 79.2229 28.5148H73.8937C73.8937 28.5148 70.8996 28.4664 70.8996 31.4086V36.2732C70.8996 36.2732 70.4449 39.2171 76.3292 39.2171H76.3292ZM79.292 37.5161C79.165 37.5162 79.0393 37.4913 78.9219 37.4428C78.8046 37.3942 78.698 37.323 78.6082 37.2332C78.5184 37.1435 78.4472 37.0368 78.3987 36.9195C78.3502 36.8022 78.3253 36.6764 78.3254 36.5495C78.3252 36.4225 78.3502 36.2967 78.3987 36.1794C78.4472 36.0621 78.5184 35.9554 78.6082 35.8657C78.698 35.7759 78.8046 35.7047 78.9219 35.6561C79.0393 35.6076 79.165 35.5826 79.292 35.5828C79.419 35.5826 79.5447 35.6076 79.662 35.6561C79.7794 35.7046 79.886 35.7758 79.9757 35.8656C80.0655 35.9554 80.1367 36.062 80.1853 36.1793C80.2338 36.2967 80.2587 36.4224 80.2586 36.5494C80.2587 36.6764 80.2338 36.8021 80.1853 36.9194C80.1367 37.0368 80.0655 37.1434 79.9757 37.2331C79.886 37.3229 79.7794 37.3941 79.662 37.4427C79.5447 37.4912 79.419 37.5161 79.292 37.516V37.5161Z",
    fill: "url(#paint1_linear_1049_11520)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1049_11520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1049_11520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7353 40.4412C38.4601 40.4412 43.9117 34.9896 43.9117 28.2647C43.9117 21.5398 38.4601 16.0882 31.7353 16.0882C25.0104 16.0882 19.5588 21.5398 19.5588 28.2647C19.5588 34.9896 25.0104 40.4412 31.7353 40.4412Z",
    fill: "#2CA01C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9412 28.2648C22.9412 30.8895 25.0517 33.0001 27.6764 33.0001H28.3529V31.2413H27.6764C26.0259 31.2413 24.7 29.9154 24.7 28.2648C24.7 26.6143 26.0258 25.2884 27.6764 25.2884H29.2999C29.2999 25.2884 29.2999 34.326 29.2999 34.4883C29.2999 35.4625 30.0847 36.2472 31.0588 36.2472V23.5296C31.0588 23.5296 29.2458 23.5296 27.6764 23.5296C25.0517 23.5296 22.9412 25.6672 22.9412 28.2648ZM35.7941 23.5296H35.1176V25.2884H35.7941C37.4447 25.2884 38.7705 26.6143 38.7705 28.2648C38.7705 29.9154 37.4447 31.2413 35.7941 31.2413H34.1706C34.1706 31.2413 34.1706 22.2037 34.1706 22.0413C34.1706 21.0672 33.3858 20.2825 32.4117 20.2825V33.0001C32.4117 33.0001 34.2246 33.0001 35.7941 33.0001C38.4188 33.0001 40.5294 30.8895 40.5294 28.2648C40.5294 25.6672 38.4188 23.5296 35.7941 23.5296Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1049_11520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 54,
    width: 36,
    height: 36,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4853 71.3853H27.5853V73.2853H29.4853V71.3853ZM33.2853 71.3853H31.3853V73.2853H33.2853V71.3853ZM37.0853 71.3853H35.1853V73.2853H37.0853V71.3853ZM38.9853 64.7353H38.0353V62.8353H36.1353V64.7353H28.5353V62.8353H26.6353V64.7353H25.6853C24.6308 64.7353 23.7948 65.5903 23.7948 66.6353L23.7853 79.9353C23.7853 80.4392 23.9855 80.9225 24.3418 81.2788C24.6981 81.6351 25.1814 81.8353 25.6853 81.8353H38.9853C40.0303 81.8353 40.8853 80.9803 40.8853 79.9353V66.6353C40.8853 65.5903 40.0303 64.7353 38.9853 64.7353ZM38.9853 79.9353H25.6853V69.4853H38.9853V79.9353Z",
    fill: "#805AF6",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1049_11520",
    x: 44,
    y: 44,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1049_11520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1049_11520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1049_11520",
    x: 44,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1049_11520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1049_11520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1049_11520",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1049_11520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1049_11520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1049_11520",
    x: 0,
    y: 44,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1049_11520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1049_11520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1049_11520",
    x1: 67.2924,
    y1: 19.1385,
    x2: 78.2839,
    y2: 30.0203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1049_11520",
    x1: 74.0375,
    y1: 26.1251,
    x2: 85.8411,
    y2: 37.2834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_11520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2353,
    height: 22.1464,
    fill: "white",
    transform: "translate(65.147 17.1471)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1049_11520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3529,
    height: 24.3529,
    fill: "white",
    transform: "translate(19.5588 16.0882)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpIntegrationOptions);
export default __webpack_public_path__ + "static/media/pp-integration-options.76b338f506425c833372174aebdb4b75.svg";
export { ForwardRef as ReactComponent };